// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RD-z","hovered":"SD-z","hoverImage":"TD-z","mainImage":"UD-z","imageNoBackground":"VD-z","fullSizeImage":"WD-z"};